<template>
  <v-text-field v-bind="$props" v-on="$listeners">
    <template
      v-for="slot in Object.keys($scopedSlots)"
      :slot="slot"
      slot-scope="scope"
      @input="onInput"
    >
      <slot :name="slot" v-bind="scope" />
    </template>
  </v-text-field>
</template>

<script>
import { VTextField } from 'vuetify/lib';

export default {
  name: 'NumberTextField',
  extends: VTextField,
  // props: {
  //   value: {
  //     type: Number,
  //     default: 0,
  //   },
  // },
};
</script>
